module.exports = __webpack_public_path__ + "img/sao_paulo.f3976efe.jpg";